import { Button } from "@/components/ui/button";
import UnAuthenticatedLayout from "../layouts/UnAuthenticatedLayout";
import {
  AuthCard,
  AuthCardContainer,
  AuthCardHeader,
  AuthCardTitle,
  AuthCardDescription,
  CardContent,
} from "@/components/ui/auth-card";
import { track, LogEvents } from "@/analytics/track";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const ErrorView = () => {
  const { t } = useTranslation("common");
  useEffect(() => {
    track({ event: LogEvents.ErrorBoundaryShown.name, channel: LogEvents.ErrorBoundaryShown.channel, path: window.location.pathname });
  }, []);
  return (
    <UnAuthenticatedLayout>
      <AuthCard>
        <AuthCardContainer>
          <AuthCardHeader>
            <AuthCardTitle>{t("errors.pageTitle")}</AuthCardTitle>
            <AuthCardDescription>{t("errors.pageDescription")}</AuthCardDescription>
          </AuthCardHeader>
          <CardContent>
            <Button asChild className="w-full sm:w-auto">
              <a href="/">{t("errors.backToHome")}</a>
            </Button>
          </CardContent>
        </AuthCardContainer>
      </AuthCard>
    </UnAuthenticatedLayout>
  );
};

export default ErrorView;
